// extracted by mini-css-extract-plugin
export var barContainer = "_31-0";
export var extraThin = "_31-3";
export var fillBar = "_31-6";
export var fillContainer = "_31-4";
export var overflow = "_31-8";
export var overflowContainer = "_31-5";
export var regular = "_31-7";
export var thick = "_31-1";
export var thin = "_31-2";